__webpack_require__.p = "/Appunti-Blockchain/";